module.exports = {"id":"210625","name":"Kevin Mbabu","rating":"71","photo":"./data/images/photos/1/210625.png","club":{"name":"BSC Young Boys","logo":"./data/images/clubs/BSCYoungBoys.png"},"positions":["DD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KevinMbabu0.json
// module id = 2346
// module chunks = 0